export { setupMintbaseWallet } from '@mintbase-js/wallet';
